﻿$(function () {
    // Prevent bootstrap modal content from caching
    $(document).on("hidden.bs.modal", ".modal", function () {
        $(this).removeData("bs.modal");
    });
});

export function closeModal() {
    $("button.close").click();
}